import { useEffect, useMemo, useRef, useState } from "react";
import { inp } from "./ledgerUtils";

// Hesap seçici: kod veya ada göre arama; onlyDetay=true → yalnız kayıt yapılabilir (detay) hesaplar
export default function AccountPicker({ accounts, value, onChange, onlyDetay = true, placeholder = "Hesap kodu / adı…", testid = "account-picker", className = "" }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  const selected = accounts.find((a) => a.code === value);
  useEffect(() => {
    const onDoc = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc); return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  const list = useMemo(() => {
    const pool = accounts.filter((a) => (onlyDetay ? a.kind === "detay" : a.kind !== "grup"));
    const k = q.trim().toLocaleLowerCase("tr");
    return (k ? pool.filter((a) => a.code.startsWith(k) || a.name.toLocaleLowerCase("tr").includes(k)) : pool).slice(0, 60);
  }, [accounts, q, onlyDetay]);
  return (
    <div ref={box} className={`relative ${className}`} data-testid={testid}>
      <input value={open ? q : selected ? `${selected.code} ${selected.name}` : q} placeholder={placeholder} data-testid={`${testid}-input`}
        onFocus={() => { setOpen(true); setQ(""); }} onChange={(e) => { setQ(e.target.value); setOpen(true); }}
        className={`${inp} w-full font-mono ${selected && !open ? "font-semibold" : ""}`} />
      {open && (
        <div className="absolute z-30 mt-1 w-full max-h-64 overflow-auto bg-white border border-slate-300 rounded-md shadow-lg" data-testid={`${testid}-list`}>
          {list.length === 0 && <div className="px-3 py-2 text-xs text-slate-400">Eşleşen hesap yok</div>}
          {list.map((a) => (
            <button key={a.code} type="button" onMouseDown={() => { onChange(a.code); setOpen(false); setQ(""); }} data-testid={`${testid}-opt-${a.code}`}
              className={`w-full text-left px-3 py-1.5 text-xs hover:bg-amber-50 flex items-center gap-2 ${a.code === value ? "bg-slate-100" : ""}`}>
              <span className="font-mono text-slate-700 w-28 shrink-0">{a.code}</span><span className="truncate">{a.name}</span>
              {a.kind !== "detay" && <span className="ml-auto text-[9px] uppercase text-amber-700">ana</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
